import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getLinks } from "UserAuthorized/actions/linksMagicLink";
import { selectMagicLink } from "UserAuthorized/selectors/linksMagicLinkSelector";
import MyLinksTable from "../MyLinksTable";

const mapStateToProps = state => {
  return {
    myLinks: selectMagicLink(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getLinks: () => dispatch(getLinks())
  };
};

class MyLinkContainer extends React.Component {
  static propTypes = {
    myLinks: PropTypes.array
  };
  static defaultProps = {
    myLinks: [{}]
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { myLinks } = this.props;
    {
      return (
        <React.Fragment>
          <MyLinksTable getLinks={this.props.getLinks} myLinks={myLinks} />
        </React.Fragment>
      );
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyLinkContainer);
